import React from 'react';
import TagId from '~/constants/srp/TagId';
import DeliveryTruckIcon from '~/icons/srp/DeliveryTruckIcon';
import NewPriceIcon from '~/icons/srp/NewPriceIcon';
import PlugIcon from '~/icons/srp/PlugIcon';
import TagIcon from '~/icons/srp/TagIcon';

const getSubText = (
  key: string
): {
  subText: string;
  Icon: React.JSX.Element;
  dataQa?: string;
} => {
  switch (key) {
    case 'isFreeDelivery':
      return {
        Icon: <DeliveryTruckIcon />,
        subText: 'Vehicles without shipping fees and available sooner.',
        dataQa: 'free-shipping-copy'
      };
    case TagId.GreatDeal.toString():
      return {
        Icon: <TagIcon />,
        subText:
          'Vehicles priced lower than the Kelley Blue Book® Typical Listing Price.',
        dataQa: 'great-deal-copy'
      };
    case TagId.PriceDrop.toString():
      return {
        Icon: <NewPriceIcon className="blue" />,
        subText:
          'We are always repricing our inventory to make room for new vehicles. Don’t miss out!',
        dataQa: 'price-drop-copy'
      };
    case TagId.EVCredit.toString():
      return {
        Icon: <PlugIcon />,
        subText:
          'Vehicles that may qualify for the Previously-Owned Clean Vehicle tax credit.',
        dataQa: 'ev-tax-credit-copy'
      };
    default:
      return { Icon: <div />, subText: '' };
  }
};

type LabelProps = {
  displayName?: string;
  labelKey: string;
};

const GreatDealsLabel = ({ displayName = '', labelKey }: LabelProps) => {
  const { Icon, subText, dataQa } = getSubText(labelKey);

  return (
    <div className="flex flex-col gap-[6px]">
      <div className="flex items-center gap-8 text-[16px] font-bold leading-[20px]">
        <span>{displayName}</span>
        {Icon}
      </div>
      <div className="text-grey-5 tl-body-s" data-qa={dataQa}>
        {subText}
      </div>
    </div>
  );
};

export default GreatDealsLabel;
